import { addEventListener, removeEventListener } from '@/utils/browser';
import { getDirectiveData, removeDirectiveData, setDirectiveData } from '@/utils/vue';

const DIRECTIVE_NAME = 'scrollEnd';
const THRESHOLD = 10;

export default {
  name: 'ScrollEnd',

  mounted(el, binding) {
    const data = getDirectiveData(el, DIRECTIVE_NAME);

    let isThrottled = false;

    data.listener = event => {
      if (isThrottled) {
        return;
      }

      isThrottled = true;

      setTimeout(() => {
        if (el.scrollHeight - el.scrollTop - THRESHOLD <= el.clientHeight) {
          binding.value(event);
        }

        isThrottled = false;
      }, 100);
    };

    setDirectiveData(el, DIRECTIVE_NAME, data);
    addEventListener(el, 'scroll', data.listener);
  },

  unmounted(el) {
    const data = getDirectiveData(el, DIRECTIVE_NAME);

    if (data.listener) {
      removeEventListener(el, 'scroll', data.listener);
    }

    removeDirectiveData(el, DIRECTIVE_NAME);
  },
};
